module.exports = __webpack_public_path__ + "static/media/delivery-of-the-keys-fixed.95e6f045.jpg";